import React, { lazy, Suspense } from "react";
// Uncomment when generating the email scripts - is_animated
// import { SPRING_BALLOON } from "constants/Games/GameConstants";

// Uncomment when generating the email scripts - SPRING BALLOON
// import Char0Var0 from "./sprites/spring_2025/Char0Var0";
// import Char0Var1 from "./sprites/spring_2025/Char0Var1";
// import Char0Var2 from "./sprites/spring_2025/Char0Var2";
// import Char1Var0 from "./sprites/spring_2025/Char1Var0";
// import Char1Var1 from "./sprites/spring_2025/Char1Var1";
// import Char1Var2 from "./sprites/spring_2025/Char1Var2";

export default function DynamicSprite({ gameType, imageId, imageFile, index }) {
    // Comment out when generating the email scripts
    const DynamicSpriteComponent = lazy(() => import(`${imageFile}`));
    return (
        <Suspense key={`${imageFile}_${index}`}>
            <DynamicSpriteComponent teamNumber={index}/>
        </Suspense>
    );

    // TODO: will need to update with future game components
    // Uncomment when generating the email scripts
    // switch(gameType) {
    //     case SPRING_BALLOON:
    //         switch (imageId) {
    //             case "kitty_balloon_0":
    //                 return <Char0Var0 teamNumber={index}/>;
    //             case "kitty_balloon_1":
    //                 return <Char0Var1 teamNumber={index}/>;
    //             case "kitty_balloon_2":
    //                 return <Char0Var2 teamNumber={index}/>;
    //             case "puppy_balloon_0":
    //                 return <Char1Var0 teamNumber={index}/>;
    //             case "puppy_balloon_1":
    //                 return <Char1Var1 teamNumber={index}/>;
    //             case "puppy_balloon_2":
    //                 return <Char1Var2 teamNumber={index}/>;
    //             default:
    //                 return <div>No Image for the image ID</div>;
    //         }
    //     default:
    //         return <div>No Images for the gameType</div>
    // }
}